import { getProxycadorHost } from "environment";
import fetch from "./utils/enhancedFetch";

export const fetchServerOwnedConfig = (locale: string) =>
  fetch(
    `${getProxycadorHost()}/proxycador/api/configurator/v1/config?locale=${locale}`
  ).then((resp) => resp.json());
